import { format } from 'date-fns-tz';

export const FOREVER_UTC = Date.UTC(9999, 11, 31, 23, 59, 59, 999);

export const TIMES = {
  ONE_SECOND: 1000,
  ONE_MINUTE: 60 * 1000,
  ONE_HOUR: 60 * 60 * 1000,
  ONE_DAY: 24 * 60 * 60 * 1000
};

export function formatDateToShortDateTime(timestamp: number, timezone = 'America/New_York'): string {
  return format(new Date(timestamp), 'MM/dd/yyyy hh:mm a', { timeZone: timezone });
}

export function isWithinTimeInterval(
  targetTime: number,
  referenceTime: number,
  intervalType: 'hour' | 'minute' | 'second'
): boolean {
  switch (intervalType) {
    case 'hour':
      return targetTime <= referenceTime + TIMES.ONE_HOUR;
    case 'minute':
      return targetTime <= referenceTime + TIMES.ONE_MINUTE;
    case 'second':
      return targetTime <= referenceTime + TIMES.ONE_SECOND;
    default:
      return false;
  }
}

export function formatMillisecondsToHHMMSS(ms: number) {
  const hours = String(Math.floor(ms / TIMES.ONE_HOUR)).padStart(2, '0');
  const minutes = String(Math.floor((ms % TIMES.ONE_HOUR) / TIMES.ONE_MINUTE)).padStart(2, '0');
  const seconds = String(Math.floor((ms % TIMES.ONE_MINUTE) / 1000)).padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}

export function isValidUtc(value: number | string | null | undefined): boolean {
  if (value == null) return false;

  const n = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(n) || n <= 0) return false;

  // Reject clearly too small or too large values
  // Between 1970 and year ~2500 (in ms)
  return n > 1e11 && n < 2e12; // milliseconds range
}

export const toMs = (iso?: string) => (iso ? Date.parse(iso) : undefined);
